import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { C, Btn } from "../components/UI";

export default function VagasSalvas() {
  const navigate = useNavigate();
  const [filtro, setFiltro] = useState("todas");

  // Dados de exemplo
  const vagasSalvas = [
    {
      id: 1,
      titulo: "Analista de Marketing Digital",
      empresa: "Tech Solutions Ltda",
      localizacao: "Sao Paulo, SP",
      modelo: "Hibrido",
      salario: "R$ 5.000 - R$ 7.000",
      nota_empresa: 4.2,
      data_salva: "20/03/2024",
      status: "ativa",
      valores: ["flexibilidade", "crescimento"]
    },
    {
      id: 2,
      titulo: "Coordenadora de Projetos",
      empresa: "Startup Inovacao",
      localizacao: "Remoto",
      modelo: "Remoto",
      salario: "R$ 8.000 - R$ 10.000",
      nota_empresa: 4.8,
      data_salva: "18/03/2024",
      status: "ativa",
      valores: ["mulheres_lideranca", "bem_estar", "maternidade"]
    },
    {
      id: 3,
      titulo: "Assistente de RH",
      empresa: "Corporacao XYZ",
      localizacao: "Rio de Janeiro, RJ",
      modelo: "Presencial",
      salario: "R$ 3.500 - R$ 4.500",
      nota_empresa: 3.5,
      data_salva: "10/03/2024",
      status: "encerrada",
      valores: ["equidade_salarial"]
    }
  ];

  const valoresLabels = {
    equidade_salarial: "Equidade salarial",
    mulheres_lideranca: "Mulheres na lideranca",
    crescimento: "Crescimento",
    flexibilidade: "Flexibilidade",
    trabalho_hibrido: "Trabalho hibrido",
    bem_estar: "Bem-estar",
    maternidade: "Maternidade",
    familia: "Familia",
    ambiente_saudavel: "Ambiente saudavel"
  };

  const vagasFiltradas = filtro === "todas" 
    ? vagasSalvas 
    : vagasSalvas.filter(v => v.status === filtro);

  const removerVaga = (id) => {
    alert("Vaga removida dos salvos!");
  };

  return (
    <div style={{ minHeight: "100vh", background: C.bg }}>
      {/* Header */}
      <section style={{ background: C.roseMid, padding: "60px 20px 40px", textAlign: "center" }}>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 36, color: "#fff", marginBottom: 8 }}>
          Vagas Salvas
        </h1>
        <p style={{ color: "rgba(255,255,255,0.8)", fontSize: 16 }}>
          Acompanhe as vagas do seu interesse
        </p>
      </section>

      <section style={{ maxWidth: 900, margin: "0 auto", padding: "40px 20px" }}>
        {/* Estatisticas */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16, marginBottom: 32 }}>
          <div style={{ background: C.surface, borderRadius: 12, padding: 20, border: `1px solid ${C.border}`, textAlign: "center" }}>
            <span style={{ fontSize: 32, fontWeight: 700, color: C.roseMid }}>{vagasSalvas.length}</span>
            <p style={{ fontSize: 13, color: C.textSec, marginTop: 4 }}>Vagas salvas</p>
          </div>
          <div style={{ background: C.surface, borderRadius: 12, padding: 20, border: `1px solid ${C.border}`, textAlign: "center" }}>
            <span style={{ fontSize: 32, fontWeight: 700, color: "#22C55E" }}>{vagasSalvas.filter(v => v.status === "ativa").length}</span>
            <p style={{ fontSize: 13, color: C.textSec, marginTop: 4 }}>Vagas ativas</p>
          </div>
          <div style={{ background: C.surface, borderRadius: 12, padding: 20, border: `1px solid ${C.border}`, textAlign: "center" }}>
            <span style={{ fontSize: 32, fontWeight: 700, color: "#6B7280" }}>{vagasSalvas.filter(v => v.status === "encerrada").length}</span>
            <p style={{ fontSize: 13, color: C.textSec, marginTop: 4 }}>Encerradas</p>
          </div>
        </div>

        {/* Filtros */}
        <div style={{ display: "flex", gap: 12, marginBottom: 24 }}>
          {[
            { id: "todas", label: "Todas" },
            { id: "ativa", label: "Ativas" },
            { id: "encerrada", label: "Encerradas" }
          ].map(f => (
            <button
              key={f.id}
              onClick={() => setFiltro(f.id)}
              style={{
                padding: "8px 16px",
                borderRadius: 20,
                border: "none",
                background: filtro === f.id ? C.roseMid : C.surface,
                color: filtro === f.id ? "#fff" : C.textSec,
                fontSize: 13,
                fontWeight: 500,
                cursor: "pointer",
                transition: "all 0.15s"
              }}
            >
              {f.label}
            </button>
          ))}
        </div>

        {/* Lista de vagas */}
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {vagasFiltradas.map(vaga => (
            <div key={vaga.id} style={{ 
              background: C.surface, 
              borderRadius: 16, 
              padding: 24, 
              border: `1px solid ${C.border}`,
              opacity: vaga.status === "encerrada" ? 0.7 : 1
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
                <div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                    <h3 style={{ fontSize: 18, fontWeight: 600, color: C.textMain }}>
                      {vaga.titulo}
                    </h3>
                    {vaga.status === "encerrada" && (
                      <span style={{
                        padding: "2px 8px",
                        borderRadius: 10,
                        fontSize: 10,
                        background: "#E5E7EB",
                        color: "#6B7280"
                      }}>
                        Encerrada
                      </span>
                    )}
                  </div>
                  <p style={{ fontSize: 14, color: C.roseMid, fontWeight: 500 }}>{vaga.empresa}</p>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  <span style={{ color: "#F59E0B", fontSize: 14 }}>★</span>
                  <span style={{ fontSize: 14, fontWeight: 600, color: C.textMain }}>{vaga.nota_empresa}</span>
                </div>
              </div>

              <div style={{ display: "flex", flexWrap: "wrap", gap: 16, marginBottom: 16 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <span style={{ fontSize: 14 }}>📍</span>
                  <span style={{ fontSize: 13, color: C.textSec }}>{vaga.localizacao}</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <span style={{ fontSize: 14 }}>🏠</span>
                  <span style={{ fontSize: 13, color: C.textSec }}>{vaga.modelo}</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <span style={{ fontSize: 14 }}>💰</span>
                  <span style={{ fontSize: 13, color: C.textSec }}>{vaga.salario}</span>
                </div>
              </div>

              {vaga.valores.length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
                  {vaga.valores.map(valor => (
                    <span key={valor} style={{
                      padding: "4px 10px",
                      borderRadius: 12,
                      fontSize: 11,
                      background: C.rosePale,
                      color: C.roseMid
                    }}>
                      {valoresLabels[valor]}
                    </span>
                  ))}
                </div>
              )}

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 12, color: C.textSec }}>Salva em {vaga.data_salva}</span>
                <div style={{ display: "flex", gap: 12 }}>
                  <button 
                    onClick={() => removerVaga(vaga.id)}
                    style={{ 
                      background: "none", 
                      border: "none", 
                      color: "#DC2626", 
                      fontSize: 13, 
                      cursor: "pointer"
                    }}
                  >
                    Remover
                  </button>
                  {vaga.status === "ativa" && (
                    <Btn variant="primary" style={{ padding: "8px 16px", fontSize: 13 }}>
                      Candidatar-se
                    </Btn>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Botao explorar vagas */}
        <div style={{ textAlign: "center", marginTop: 32 }}>
          <Btn variant="primary" onClick={() => navigate("/vagas")}>
            Explorar mais vagas
          </Btn>
        </div>
      </section>
    </div>
  );
}
